export function toPriceString(price: number | undefined | null, defaultVal?: string) {
    if (price == null) {
        return defaultVal ?? '\u00A0';
    }

    return (Math.round(price * 100) / 100)
        .toFixed(2)
        .replace('.', ',')
        .toLocaleLowerCase()
        .replace('infinity', '∞');
}
